import React from 'react';
import { commonRadioOptions } from '@utils/commons';
import { AcmpType } from '../../../utils';

interface AcmpProps {
  acmp: AcmpType;
  setAcmp: React.Dispatch<React.SetStateAction<AcmpType>>;
}

const HasAcmp: React.FC<AcmpProps> = ({ acmp, setAcmp }) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <fieldset className="govuk-fieldset">
        <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
          <h1 className="govuk-fieldset__heading">
            Has a Medical Anticipatory Clinical Management Plan (ACMP) been
            completed?
          </h1>
        </legend>
        <div className="govuk-radios" data-module="govuk-radios">
          {commonRadioOptions.map(option => (
            <div className="govuk-radios__item" key={option.value}>
              <input
                className="govuk-radios__input"
                id="acmp"
                name="hasAcmp"
                type="radio"
                value={option.value}
                checked={acmp.status === option.value}
                onChange={() => {
                  setAcmp(prev => ({
                    ...prev,
                    status: option.value,
                  }));
                }}
              />
              <label
                className="govuk-label govuk-radios__label"
                htmlFor={option.value}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </fieldset>
    </div>
  );
};

export default HasAcmp;
